<template>
  <HiSubPage>
    <hi-page-column card width="25vw" fix-width gradient-top gradient-softer>
      <LeadDetails :id="leadId"></LeadDetails>
    </hi-page-column>
    <hi-page-column card grow gradient-top>
      <!--      <hi-row grow>test</hi-row>-->
      <!--      <HiTextArea :handler="commentHandler" class="comment-input"></HiTextArea>-->
      <Comments type="leads" :id="leadId"></Comments>
    </hi-page-column>
  </HiSubPage>
</template>

<script>
import HiPageColumn from "@/components/scaffold/HiPageColumn";
import LeadDetails from "@/components/leads/LeadDetails";
import HiSubPage from "@/components/scaffold/HiSubPage";
// import HiRow from "@/components/scaffold/HiRow";
// import HiTextArea from "@/components/HiTextArea";
// import { api } from "@/api";
import Comments from "@/components/Comments";
export default {
  name: "Leads_ID",
  components: {
    Comments,
    // HiTextArea,
    // HiRow,
    LeadDetails,
    HiPageColumn,
    HiSubPage
  },
  data() {
    return {
      leadId: null
    };
  },
  methods: {},
  watch: {
    $route: {
      immediate: true,
      handler(route) {
        if (route.params.id) {
          this.leadId = route.params.id;
        }
      }
    }
  }
};
</script>

<style lang="scss" scoped>
@import "~@/styles/variables.scss";
.comment-input {
  background-color: $light4;
  box-shadow: inset 1px 1px 3px #999999;
  padding: 2px;
}
</style>
